export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_CLIENT_ID || '',
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin + "/auth-end.html"
    },
    cache: {
        cacheLocation: 'localStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        allowRedirectInIframe: true,
    },
};

export const loginRequest = {
    scopes: ["User.Read", "Contacts.Read", "People.Read"],
    prompt: "consent"
};
